import * as THREE from 'three';
import Experience from './Experience.js';

export default class Raycaster {
  constructor() {
    this.experience = new Experience();
    this.preLoader = this.experience.preloader;
    this.sizes = this.experience.sizes;
    this.resources = this.experience.resources;
    this.config = this.experience.config;
    this.camera = this.experience.camera;
    this.logic = this.camera.logic;
    this.preLoader.on('start', () => {
      this.config.touch = this.experience.config.touch;
      this.raycaster = new THREE.Raycaster();
      this.raycaster.layers.enableAll();
      this.raycaster.layers.disable(9);

      this.cursorDown = new THREE.Vector2();
      this.cursor = new THREE.Vector2();
      this.setUp();
      if (this.sizes.mode === 'bigScreen') {
        this.setUpHover();
      }
    });
  }
  setUp() {
    this.objectsToTest = [];

    this.objectsToTest.push(this.experience.world.raycasterObjects.twiterBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.gmailBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.linkedinBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.gitBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.resumeBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.contactBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.skillsBox);
    this.objectsToTest.push(this.experience.world.raycasterObjects.projectsBox);

    this.touchedPoints = [];
    window.addEventListener('pointerdown', (event) => {
      this.touchedPoints.push(event.pointerId);

      //testing with bigger range for not that sensitive touch
      this.cursorXMin = Math.abs(
        ((event.clientX / this.sizes.width) * 2 - 1) * 0.5
      );
      this.cursorXMax = Math.abs(
        ((event.clientX / this.sizes.width) * 2 - 1) * 1.6
      );

      this.cursorYMin = Math.abs(
        ((event.clientY / this.sizes.height) * 2 - 1) * 0.5
      );
      this.cursorYMax = Math.abs(
        ((event.clientY / this.sizes.height) * 2 - 1) * 1.6
      );
    });

    window.addEventListener('pointerup', (event) => {
      this.cursor.x = (event.clientX / this.sizes.width) * 2 - 1;
      this.cursor.y = -(event.clientY / this.sizes.height) * 2 + 1;

      this.absX = Math.abs(this.cursor.x);
      this.absY = Math.abs(this.cursor.y);

      if (
        this.touchedPoints.length === 1 &&
        this.absX > this.cursorXMin &&
        this.absX < this.cursorXMax &&
        this.absY > this.cursorYMin &&
        this.absY < this.cursorYMax
      ) {
        this.click(this.cursor);

        this.touchedPoints = [];
      } else {
        this.touchedPoints = [];
      }
    });
  }

  click(cursor) {
    this.raycaster.setFromCamera(cursor, this.camera.instance);
    this.intersectsObjects = this.raycaster.intersectObjects(
      this.objectsToTest
    );

    if (this.intersectsObjects.length) {
      this.selectedModel = this.intersectsObjects[0].object;
      if (this.selectedModel.name === 'skills') {
        this.camera.camControls.toSkills();
      }
      if (this.selectedModel.name === 'projects') {
        this.camera.camControls.toProjects();
      }
      if (this.selectedModel.name === 'contact') {
        this.camera.camControls.toContact();
      }

      if (
        this.selectedModel.name === 'twitter' &&
        this.logic.mode === 'contact'
      ) {
        window.open('https://twitter.com/dfdwebsites');
      }
      if (
        this.selectedModel.name === 'gmail' &&
        this.logic.mode === 'contact'
      ) {
        window.location.href = 'mailto: www.dfdwebsites@gmail.com';
      }
      if (
        this.selectedModel.name === 'linkedin' &&
        this.logic.mode === 'contact'
      ) {
        window.open('https://www.linkedin.com/in/iordanis-tselepidis/');
      }
      if (this.selectedModel.name === 'git' && this.logic.mode === 'contact') {
        window.open('https://github.com/dfdwebsites');
      }
      if (
        this.selectedModel.name === 'resume' &&
        this.logic.mode === 'contact'
      ) {
        const resume = document.createElement('a');
        resume.href = '/assets/Tselepidis-Iordanis-CV.pdf';
        resume.download = '/assets/Tselepidis-Iordanis-CV.pdf';
        resume.dispatchEvent(new MouseEvent('click'));
      }
    }
  }
  setUpHover() {
    window.addEventListener('pointermove', (event) => {
      this.cursor.x = (event.clientX / this.sizes.width) * 2 - 1;
      this.cursor.y = -(event.clientY / this.sizes.height) * 2 + 1;
    });
  }
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  update() {
    if (this.sizes.mode === 'bigScreen' && this.cursor) {
      this.raycaster.setFromCamera(this.cursor, this.camera.instance);
      this.intersectsObjects = this.raycaster.intersectObjects(
        this.objectsToTest
      );
      if (this.intersectsObjects.length > 0 && this.logic.mode === 'contact') {
        document.body.style.cursor = 'pointer';
      } else {
        document.body.style.cursor = 'default';
      }
    }
  }
}
